import React, { useState, useEffect, useRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import LiquidContainer from "../../components/LiquidContainer";
import MainLanding from "./MainLanding";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// Individual PDF item that only renders when visible
const LazyPDF = ({ file, width }) => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Once loaded, keep it loaded
        }
      },
      { rootMargin: "200px" } // Starts loading 200px before it scrolls into view
    );

    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} style={{ minHeight: "400px", width: "100%", display: 'flex', justifyContent: 'center' }}>
      {isVisible ? (
        <Document file={file} loading={<p>Cargando PDF...</p>}>
          <Page
            pageNumber={1}
            width={width}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
      ) : (
        <div className="text-muted">Desliza para cargar...</div>
      )}
    </div>
  );
};

const Agenda = () => {
  const staticPath = "/static/images/agendas";
  const days = ["18", "19", "20", "21", "22", "23", "24"];
  
  // Calculate width once to avoid re-renders
  const pdfWidth = Math.min(window.innerWidth - 40, 600);

  return (
    <MainLanding>
      <LiquidContainer backgroundColor="#efefefe0" ancho="95vw" alto="85vh" borderline="0px" boxSdw="none">
        <div
          className="d-flex flex-column align-items-center py-4"
          style={{ height: "100%", width: "100%", overflowY: "auto", overflowX: "hidden" }}
        >
          <h2 className="mb-4 text-dark font-weight-bold">Agenda</h2>

          {days.map((day) => (
            <div key={day} className="mb-5 w-100 px-2 d-flex flex-column align-items-center">
              <h5 className="text-secondary mb-3">Marzo {day}</h5>
              
              <div style={{ 
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)", 
                borderRadius: "12px", 
                overflow: "hidden",
                maxWidth: "100%" 
              }}>
                <LazyPDF 
                  file={`${staticPath}/GEN_MARZO ${day}.pdf`} 
                  width={pdfWidth} 
                />
              </div>
            </div>
          ))}
        </div>
      </LiquidContainer>
    </MainLanding>
  );
};

export default Agenda;